import React from 'react';
import { ArrowUpRight, Leaf } from 'lucide-react';
import { projects } from '../mock';

const Projects = () => {
  return (
    <section id="projects" className="py-24 bg-gradient-to-b from-emerald-50/40 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-emerald-200 bg-white text-emerald-700 text-xs font-semibold uppercase tracking-widest">
            <Leaf className="w-3.5 h-3.5" /> Our Projects
          </div>
          <h2 className="mt-5 text-4xl md:text-5xl font-extrabold text-[#0b1a1a] leading-tight">
            Our Latest <span className="text-emerald-600">Projects</span>
          </h2>
          <p className="mt-5 text-slate-600 leading-relaxed">
            Explore forward-thinking initiatives driving the future of clean energy through advanced CBG solutions — from innovative waste-to-energy processes to sustainable biogas technologies.
          </p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {projects.map((p) => (
            <a key={p.title} href="#projects" className="group relative rounded-3xl overflow-hidden shadow-md hover:shadow-2xl hover:shadow-emerald-100 transition-all duration-500">
              <div className="aspect-[4/5] overflow-hidden">
                <img src={p.img} alt={p.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-[#0b1a1a]/90 via-[#0b1a1a]/20 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-6 flex items-end justify-between">
                <div className="text-white">
                  <div className="text-xs font-semibold uppercase tracking-wider text-emerald-300">{p.tag}</div>
                  <div className="text-xl font-extrabold mt-1">{p.title}</div>
                </div>
                <div className="w-11 h-11 rounded-full bg-white text-emerald-600 grid place-items-center group-hover:bg-emerald-500 group-hover:text-white transition-colors">
                  <ArrowUpRight className="w-5 h-5" />
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
